import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const LoginRedirect = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/user-registration');
  };

  return (
    <div className="bg-muted/50 rounded-xl p-6 border border-border">
      <div className="text-center space-y-4">
        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
          <Icon name="LogIn" size={24} className="text-primary" />
        </div>
        
        <div>
          <h3 className="font-semibold text-foreground mb-2">Already have an account?</h3>
          <p className="text-sm text-muted-foreground">
            Sign in to access your financial plans and continue your journey
          </p>
        </div>

        <Button
          variant="outline"
          size="default"
          onClick={handleLoginClick}
          iconName="ArrowRight"
          iconPosition="right"
          fullWidth
        >
          Sign In to Your Account
        </Button>

        <div className="pt-4 border-t border-border">
          <p className="text-xs text-muted-foreground">
            Need help? Contact our support team at{' '}
            <a href="mailto:support@firebydexterr.com" className="text-primary hover:underline">
              support@firebydexterr.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginRedirect;